<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação de Exames"
    >
        <List
            v-if="layout === 'list'"
            :data="data"
            @edit="handleEdit"
        />

        <Form
            v-else
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
            style="margin-top: -1rem; margin-bottom: -1rem;"
        />

        <template v-slot:footer="{ cancel }">
            <template v-if="layout === 'list'">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="printExamesImagem"
                    :disabled="!hasPedidoExame(enums.tipoExame.IMAGEM)"
                >
                    Imprimir exames de imagem
                </rkm-button>

                <rkm-button
                    @click="printExamesLaboratoriais"
                    :disabled="!hasPedidoExame(enums.tipoExame.LABORATORIAL)"
                >
                    Imprimir exames laboratoriais
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    :disabled="!!data.form.pedidosExames.find(p => isNaN(p.id))"
                    color="primary"
                >
                    Solicitar Exame
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button @click="layout = 'list'">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Enums.
import tipoExame from '@/enums/pronto-atendimento/parametrizacao/tipoExame'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form, List },
    mixins: [repository, error],
    data: () => ({
        layout: null,
        model: null,
        enums: {
            tipoExame
        },
    }),
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.layout = 'list'
            this.$refs.RkmModal.show()
        },
        handleCreate() {
            this.model = Object.assign({}, {
                id: null,
                lotacao: {
                    ocupacao: {
                        codigo: this.data.form.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: this.data.form.lotacao.profissional.nome,
                    },
                },
                exames: [],
                urgente: false,
                justificativa: null,
                exame: null,
            })

            this.data.form.kits.map(k => k.exames.map(e => e.checked = false))

            this.layout = 'form'
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                id: item.id,
                lotacao: {
                    ocupacao: {
                        codigo: item.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: item.lotacao.profissional.nome,
                    },
                },
                exames: item.exames,
                urgente: item.urgente,
                justificativa: item.justificativa,
                exame: null,
            })

            this.data.form.kits.map(k => k.exames.map(exame => {

                exame.checked = !!this.model.exames.find(e => e.id === exame.id)
            }))

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        saved() {
            this.layout = 'list'
        },
        hasPedidoExame(tipoExameId) {

            return this.data.form.pedidosExames.some(pedido => Number.isInteger(pedido.id)
                && pedido.exames.some(exame => exame.tipoId === tipoExameId))
        },
        printExamesImagem() {

            this.openFile(() => this.repositories.impressao.atendimentoMedico
                .solicitacaoExamesImagem(this.data.model.atendimentoId))
        },
        printExamesLaboratoriais() {

            this.openFile(() => this.repositories.impressao.atendimentoMedico
                .solicitacaoExamesLaboratoriais(this.data.model.atendimentoId))
        },
        openFile(repository) {

            this.setLoading()

            repository()
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>